import type { useNativeAppStore } from '@/store/native-app-store'
import { ADJUST_TOKENS } from '@/types/logger.types'

import { getNativeProductPriceAndCurrency } from './helpers'
import type { NativePaymentPack } from './types'

type NativeAppStore = Pick<ReturnType<typeof useNativeAppStore>, 'postMessage'>

function confirmNativePurchase(nativeAppStore: NativeAppStore, transactionId: string, status: 'success' | 'failed') {
    nativeAppStore.postMessage('purchase.confirm', { transactionId, status })
}

export function reportVerifiedNativePurchaseSuccess(
    nativeAppStore: NativeAppStore,
    transactionId: string,
    pack: NativePaymentPack,
) {
    confirmNativePurchase(nativeAppStore, transactionId, 'success')

    const { price: revenue, currency } = getNativeProductPriceAndCurrency(pack.product, pack.platform)

    nativeAppStore.postMessage('purchase.trackBillingRevenue', {
        eventToken: ADJUST_TOKENS.purchase_successful,
        revenue,
        currency,
    })
}

export function confirmFailedNativePurchase(nativeAppStore: NativeAppStore, transactionId: string) {
    confirmNativePurchase(nativeAppStore, transactionId, 'failed')
}

export function confirmRecoveredNativePurchase(nativeAppStore: NativeAppStore, transactionId: string) {
    // Recovery can replay an already reported transaction, so it must not track revenue again.
    confirmNativePurchase(nativeAppStore, transactionId, 'success')
}
